import { useEffect } from "react";
import {
  fetchExamQuestionsListRequest,
  fetchExamInstructionRequest,
} from "../../../redux/exam/examSlice";
import useAppHooks from "../../hooks/useAppHooks";

export default function InstructionScreen() {
  const { dispatch, history } = useAppHooks();

  useEffect(() => {
    dispatch(fetchExamInstructionRequest());
  }, [dispatch]);

  const handleStart = async () => {
    dispatch(fetchExamQuestionsListRequest());
    history.push("/test");
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold">Instructions</h2>
      {/* render instructions here */}
      <button onClick={handleStart}>Start Test</button>
    </div>
  );
}
